const configCommon = require('./config.common.json');

let config: Bemob.Config;

// we need condition for require, otherwise all configs will be included in generated code
switch(process.env.VUE_APP_CONFIG_NAME) {
  case 'production':
    config = require('./config.production.json');
    break;
    
  case 'beta':
    config = require('./config.beta.json');
    break;

  case 'local':
    config = require('./config.local.json');
    break;

  case 'preview':
    config = require('./config.preview.json');
    break;

  case 'staging':
  case 'development':
  default:
    config = require('./config.staging.json');
    break;
}

export default {
  ...configCommon,
  ...config
} as Bemob.Config;
